<div class="custom-name-cell">
    <p>
        {{cellValue.name}}
    </p>
</div>